import React from 'react';
import FileUploadService from '../../services/uploadService/UploadService';
import i18n from '../../i18n';
import {
    Box,
    IconButton,
    Link,
    List,
    ListItem,
    ListItemSecondaryAction,
    Typography
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DeleteIcon from '@mui/icons-material/Delete';
import ListItemText from '@mui/material/ListItemText';
import { LoadingButton } from '@mui/lab';

export default class DialogUploadField extends React.Component {
    // required fields on head for upload
    //uploadType: single or multiple (single by default), fileCategory: diff, appeals, fraud.. etc
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            files: [],
            errorMessage: '',
            loading: false
        };
        this.fileService = new FileUploadService(
            this.props.context.getState().server
        );
        this.fieldFileCategory = this.props.field.fileCategory;
    }

    handleFileUpload = async (event, fileCategory) => {
        if (!event.target.files || !event.target.files.length) return;
        this.setState({
            loading: true
        });
        const file = event.target.files[0];
        try {
            const uploadResult = await this.fileService.uploadFile(
                file,
                fileCategory
            );
            if (this.props.field.uploadType === 'multiple') {
                this.setState((prevState) => ({
                    files: [...prevState.files, uploadResult] }));
            } else {
                this.setState({
                    files: [uploadResult] });
            }
            this.props.onChange(this.props.field.id, uploadResult.id);
        } catch (error) {
            this.setState({ errorMessage: error.toString() });
        } finally {
            this.setState({
                loading: false
            });
        }
    };
    handleOpenFile = async (fileUuid) => {
        try {
            await this.fileService.downloadFile(fileUuid, 'token');
        } catch (error) {
            console.log('Error downloading file:', error);
            this.setState({ errorMessage: error.toString() });
        }
    };

    handleDeleteFile(id) {
        if (this.props.field.uploadType === 'multiple') {
            this.props.onChange(
                this.props.field.id,
                this.state.files.filter((value) => value.id !== id)
            );
        } else {
            this.props.onChange(this.props.field.id, null);
        }

        this.setState({
            files: this.state.files.filter((file) => file.id !== id)
        });
    }

    render() {
        const fileCategory = this.fieldFileCategory;

        const translatedLabel = i18n.t(
            `columns.${this.props.field.label}Upload`
        );
        const required = this.props.field.required;
        const requiredLabel = required ? ' *' : '';

        return (
            <Box marginY={1}>
                <Typography variant="subtitle2" gutterBottom>
                    {translatedLabel + requiredLabel}
                </Typography>

                {/* list of files */}
                {this.state.files.length > 0 && (
                    <List>
                        {this.state.files.map((file) => (
                            <ListItem key={file.id} divider>
                                <ListItemText
                                    primary={
                                        <Link
                                            component="button"
                                            underline="hover"
                                            onClick={() => {
                                                this.handleOpenFile(file.uuid);
                                            }}
                                        >
                                            {file.name}
                                        </Link>
                                    }
                                />

                                {/* remove */}
                                <ListItemSecondaryAction>
                                    <IconButton
                                        edge="end"
                                        aria-label="delete"
                                        onClick={() =>
                                            this.handleDeleteFile(file.id)
                                        }
                                    >
                                        <DeleteIcon color="error" />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                )}

                {/* hidden input for upload */}
                <input
                    id={`file-upload-${this.props.field.id}`}
                    type="file"
                    style={{ display: 'none' }}
                    onChange={(e) => this.handleFileUpload(e, fileCategory)}
                />

                {/* upload button */}
                {this.props.field.uploadType === 'multiple' ||
                this.state.files.length === 0 ? (
                        <label htmlFor={`file-upload-${this.props.field.id}`}>
                            <LoadingButton
                                loading={this.state.loading}
                                // Outlined like every other file picker: choosing a
                                // file is a step in the form, not its action.
                                variant="outlined"
                                component="span"
                                startIcon={<UploadFileIcon />}
                            >
                                {i18n.t('buttons.uploadDocument')}
                            </LoadingButton>
                        </label>
                    ) : null}

                {/* error */}
                {this.state.errorMessage && (
                    <Typography color="error" variant="body2">
                        {this.state.errorMessage}
                    </Typography>
                )}
            </Box>
        );
    }
}
